module.exports = __webpack_public_path__ + "static/media/sliderManBefore.3fb1ca7d.png";